import api from "./api";

export const fetchData = async (token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.get("api/de", config);
        return (response.data);
    } catch (error) {
        throw error;
    }
}

export const getKude = async (id, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.get(`api/de/kude/${id}`, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getXml = async (id, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.get(`api/de/xml/${id}`, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const sendDE = async (id, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        await api.post(`api/dispatch/de/${id}`, {}, config)
    } catch (error) {
        throw error;
    }
}

export const consultarLoteDE = async (cdc, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        await api.get(`api/eventos/consultaLoteDE/${cdc}`, config)
    } catch (error) {
        throw error;
    }
}

export const consultarExistenciaDE = async (cdc, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        await api.get(`api/eventos/consultaExistenciaDE/${cdc}`, config)
    } catch (error) {
        throw error;
    }
}

export const getDEs = async (opciones, token) => {
    try {

        const jsonDEQuery = {
            Buscador: opciones?.buscador || '',
            TipoDoc: opciones?.tipoDoc || null,
            Establecimiento: opciones?.establecimiento || null,
            PuntoEmision: opciones?.puntoEmision || null,
            EstadoInicial: opciones?.estadoInicial || null,
            EstadoProcesado: opciones?.estadoProcesado || null,
            Estado: opciones?.estado || null,
            TenantId: opciones?.tenantId || null,
            DesdeFechaEmision: opciones?.desdeFechaEmision || null,
            HastaFechaEmision: opciones?.hastaFechaEmision || null,
            DesdeFechaProcesado: opciones?.desdeFechaProcesado || null,
            HastaFechaProcesado: opciones?.hastaFechaProcesado || null,
            CurrentPage: opciones?.currentPage || 1,
            PageSize: opciones?.pageSize || 20
        }

        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.post("api/de/query", jsonDEQuery, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getListDEPaginated = async (query, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.get("api/de?" + query, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const reenviarEmail = async (id, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        await api.post(`api/email/reenviar/${id}`, {}, config)
    } catch (error) {
        throw error;
    }
}

export const anularDE = async (id, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        var response = await api.post(`api/eventos/borrarInvoice/${id}`, {}, config)

        return response.data;

    } catch (error) {
        throw error;
    }
}

// ==================== TENANTS ====================

export const getTenants = async (token, incluirInactivos = false) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.get(`api/tenants?incluirInactivos=${incluirInactivos}`, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getTenantById = async (id, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.get(`api/tenants/${id}`, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const createTenant = async (tenantData, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.post('api/tenants', tenantData, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateTenant = async (id, tenantData, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.put(`api/tenants/${id}`, tenantData, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteTenant = async (id, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        await api.delete(`api/tenants/${id}`, config);
    } catch (error) {
        throw error;
    }
}

// ==================== USUARIOS ====================

export const getUsuarios = async (token, incluirInactivos = false) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.get(`api/usuario?incluirInactivos=${incluirInactivos}`, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getUsuarioById = async (id, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.get(`api/usuario/${id}`, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const createUsuario = async (usuarioData, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.post('api/usuario/create', usuarioData, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const updateUsuario = async (id, usuarioData, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.put(`api/usuario/${id}`, usuarioData, config);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const deleteUsuario = async (id, token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        await api.delete(`api/usuario/${id}`, config);
    } catch (error) {
        throw error;
    }
}

export const getRoles = async (token) => {
    try {
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        const response = await api.get('api/usuario/roles', config);
        return response.data;
    } catch (error) {
        throw error;
    }
}